/**
 * Based on mxgraph 4.2.0
 */
import mxgraphFactory from "mxgraph";
var mxAbsolutePath = "/platform/runtime/common/web/@edp-pmf/mxgraph";
var topWindow = window.top;
var gspframeworkService = topWindow.gspframeworkService;
var igixBasePath = gspframeworkService && gspframeworkService.common && gspframeworkService.common.getBasePath && gspframeworkService.common.getBasePath.get ? gspframeworkService.common.getBasePath.get() : "";
window['mxiGIXBasePath'] = igixBasePath || "";
window['mxBasePath'] = window['mxBasePath'] || (window['mxiGIXBasePath'] + mxAbsolutePath);
window['mxLoadResources'] = window['mxLoadResources'] || undefined;
window['mxForceIncludes'] = window['mxForceIncludes'] || undefined;
window['mxResourceExtension'] = window['mxResourceExtension'] || undefined;
window['mxLoadStylesheets'] = window['mxLoadStylesheets'] || undefined;
window['imageBasePath'] = window['imageBasePath'] || undefined;
var lang = window['mxLanguage'] || gspframeworkService && gspframeworkService.rtf && gspframeworkService.rtf.language && gspframeworkService.rtf.language.getLanguageCode && gspframeworkService.rtf.language.getLanguageCode() || localStorage.getItem('languageCode') || 'zh-CHS';
window['mxLanguage'] = lang && String(lang).replace("-", "").toLocaleLowerCase();
window['mxDefaultLanguage'] = window['mxDefaultLanguage'] || undefined;
window['mxLanguages'] = window['mxLanguages'] || undefined;
export var mxgraphInstance = mxgraphFactory({});
//# sourceMappingURL=mxgraphFactory.js.map